import dynamic from 'next/dynamic';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import { WidgetPlugin } from './types';

import type { GalleryCarouselProps } from '@/components/organisms';
import type { ImageGalleryWidgetItem } from '@/lib/api';

export const GalleryCarouselPlugin: WidgetPlugin<GalleryCarouselProps> = {
  type: TYPES.IMAGE_GALLERY,
  template: TEMPLATES.CAROUSEL,
  component: dynamic(() =>
    import('@/components/organisms/GalleryCarousel').then(
      mod => mod.GalleryCarousel,
    ),
  ),
  mapProps: widget => {
    return {
      carouselTitle: widget.title as string,
      carouselDescription: widget.content_parameters.category?.name || '',
      items:
        widget.template.items?.map(
          (raw): ImageGalleryWidgetItem => ({
            id: raw.id.toString(),
            title: raw.title,
            long_description: '',
            position: 1,
            short_description: raw.short_description
              ? raw.short_description
              : '',
            display_on_widget: true,
            tags: [],
            customer_groups: [{ id: '', name: '', description: '' }],
            art_work: raw.art_work
              ? raw.art_work
              : { url: '', root: '', path: '' },
          }),
        ) || [],
    };
  },
};
